import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

// X-axis labels
const labels = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
];

// Dataset 1: Revenue + Expenses
const revenueData = [
  2000, 3500, 4500, 5750, 6900, 8500, 9560, 10569, 11560, 12653, 17500, 21000,
];

// Chart options generator
const generateOptions = (title, min, max) => ({
  responsive: true,
  scales: {
    y: {
      min: min - 0,
      max: max + 25000,
      color: "#F9F9F9",
      title: {
        display: true,
        text: "TopCoin UK Units",
        color: "#fff",
      },
      grid: {
        color: "#9AADFF", // 🔸 X-axis grid lines (vertical lines)
        borderDash: [5, 5],
        lineWidth: 1,
      },
      ticks: {
        callback: (value) => "" + value.toLocaleString(),
        color: "#F9F9F9",
      },
    },
    x: {
      ticks: {
        color: "#F9F9F9",
      },
       title: {
        display: true,
        text: "Time Period",
        color: "#fff",
      },
      grid: {
        color: "#9AADFF", // 🔸 X-axis grid lines (vertical lines)
        borderDash: [5, 5],
        lineWidth: 1,
      },
    },
  },
  plugins: {
    legend: {
      position: "bottom",
      labels: {
        color: "#F9F9F9",
      },
    },
    title: { display: false,  color: "#F9F9F9", text: title , position : 'bottom',},
  },
});

// Chart data generator
const generateChartData = (datasets) => ({
  labels,
  datasets,
});

const ChartCoin = () => {
  const chart1Min = Math.min(...revenueData);

  return (
    <>
      <div className="text-center py-4">
        <h4 className="text-theme">
         Graph illustrating the accumulation of TopCoin UK Points Value over the specified time period.
        </h4>
      </div>
      <div
        className="chart-wrapper"
        style={{ backgroundColor: "#000067", padding: "20px" }}
      >
        <Line
          data={generateChartData([
            {
              label: "TopCoin UK Units",
              data: revenueData,
              borderColor: "rgba(206,213,255,1)",
              backgroundColor: "rgba(206,213,255,0.2)",
              tension: 0.4,
            },
          ])}
          options={generateOptions("Time Period", chart1Min)}
        />
      </div>
    </>
  );
};

export default ChartCoin;
